import React from 'react';
import PropTypes from 'prop-types';

import styles from './RadioBulletMarker.css';

const IPropTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool,
};

const defaultProps = {
  className: '',
  selected: false,
};

const RadioBulletMarker = (props) => {
  const selectedClass = props.selected ? styles.selected : '';
  return (
    <div className={[styles.container, selectedClass, props.className].join(' ')}>
      {
        props.selected &&
        <div className={styles.internalMarker} />
      }
    </div>
  );
};

RadioBulletMarker.propTypes = IPropTypes;
RadioBulletMarker.defaultProps = defaultProps;

export { RadioBulletMarker };



// WEBPACK FOOTER //
// ./src/common/radio-bullet-marker/RadioBulletMarker.jsx